/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Back_To_LoginInputs */

const fr_totp_back_to_login = /** @type {(inputs: Totp_Back_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à la connexion`)
};

/**

* @param {Totp_Back_To_LoginInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_back_to_login = /** @type {((inputs?: Totp_Back_To_LoginInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Back_To_LoginInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_back_to_login(inputs)
});